import React from 'react';

import { CardAction } from '../CardAction';
import { HelpPanelCardView } from './HelpPanelCard.view';

export interface HelpPanelCardProps {
  name: string;
  content: React.ReactNode;
  mainAction?: CardAction;
  secondaryAction?: CardAction;
  onLinkOpen: (link: string) => void;
  onExpand: () => void;
  onCollapse: () => void;
  isOpen: boolean;
}

export const HelpPanelCard: React.FC<HelpPanelCardProps> = ({
  name,
  content,
  mainAction,
  secondaryAction,
  onLinkOpen,
  onExpand,
  onCollapse,
  isOpen,
}: HelpPanelCardProps) => {
  const onActionClick = (link?: string, callback?: () => void) => {
    if (link) {
      onLinkOpen(link);
    } else if (callback) {
      callback();
    }
  };

  return (
    <HelpPanelCardView
      name={name}
      content={content}
      mainAction={mainAction}
      secondaryAction={secondaryAction}
      onActionClick={onActionClick}
      onExpand={onExpand}
      onCollapse={onCollapse}
      isOpen={isOpen}
    />
  );
};
